import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { ChampionshipMediaKindRow } from 'modules/championship/domain/graphql/championship-media';
import React from 'react';
import UDStatusBadge, { UDStatusBadgeTone } from 'ud-ui/components/status-badge';

/** Готовность типа медиа к генерации: шаблон есть / шаблона нет / тип ещё не поддержан. */
export type MediaKindState = 'ready' | 'missing' | 'soon';

export function mediaKindState(row: ChampionshipMediaKindRow): MediaKindState {
  if (!row.supported || row.blockedReason === 'unsupported') return 'soon';
  if (row.blockedReason === 'no_template' || !row.templateName) return 'missing';
  return 'ready';
}

/** Подписи статусов. Ими же скелетон вкладки меряет ширину плашки пилюли. */
export const MEDIA_KIND_STATUS_LABELS: Record<MediaKindState, MessageDescriptor> = {
  ready: msg`Готов к генерации`,
  missing: msg`Нет шаблона`,
  soon: msg`Скоро`,
};

/** Тон пилюли; у «скоро» своего исхода нет, он нейтральный. */
const STATE_TONE: Record<MediaKindState, UDStatusBadgeTone> = {
  ready: 'success',
  missing: 'pending',
  soon: 'neutral',
};

interface MediaKindStatusProps {
  state: MediaKindState;
}

/**
 * Статус типа медиа на вкладке «Медиа» турнира — пилюля со словом, а не значок: прежний «○»
 * походил на радиокнопку и ничего не сообщал (IMGM-1509). Размер `md` — строка таблицы; плашка
 * скелетона меряется тем же `UD_STATUS_BADGE_METRICS.md`.
 */
const MediaKindStatus = ({ state }: MediaKindStatusProps) => {
  const { t } = useLingui();

  return (
    <UDStatusBadge tone={STATE_TONE[state]} size="md" data-testid="media-kind-status" data-state={state}>
      {t(MEDIA_KIND_STATUS_LABELS[state])}
    </UDStatusBadge>
  );
};

export default React.memo(MediaKindStatus);
